/* eslint-disable @typescript-eslint/no-unused-expressions */

function defer<T>() {
  let e: (value: T) => void, t: (reason?: any) => void;
  const n = new Promise<T>((resolve, reject) => {
    (e = resolve), (t = reject);
  });
  return {
    resolve: e!,
    reject: t!,
    promise: n,
  };
}
let idx = 0;
const prefix = 'jsonp_callback_' + Date.now();

export function jsonp<T>(url: string) {
  const t = defer<T>();
  const temp = document.createElement('script');
  temp.type = 'text/javascript';
  const o = (function () {
    const jsonpScript = prefix + idx;
    idx++;
    return jsonpScript;
  })();
  (window as any)[o] = (e: any) => {
    delete (window as any)[o], temp.parentNode && temp.parentNode.removeChild(temp), t.resolve(e);
  };

  let fetchUrl = url;
  try {
    const URLObj = new URL(url);
    URLObj.searchParams.set('callback', o);
    fetchUrl = URLObj.href;
  } catch (e) {
    delete (window as any)[o];
    temp.parentNode && temp.parentNode.removeChild(temp);
    t.reject(e);
    return t.promise;
  }
  temp.src = fetchUrl;
  temp.onerror = (e) => {
    delete (window as any)[o];
    temp.parentNode && temp.parentNode.removeChild(temp);
    t.reject(e);
  };
  document.head && document.head.appendChild(temp);
  return t.promise;
}
